import { boolean } from "../types/boolean";

export default function not(a) {
  a = boolean(a);
  return !a;
}
